import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  breakdown: {},
  documents: [],
  property: {},
  applicationId: null,
  mortageContracts: [],
  developerDetails: [],
  owners: [],
  contractDetail: {},
  calculatedFees: {},
  PermissionId: [],
  entity: {},
  entityAllDetails: {},
  applicationType: 'INTERPERSONAL_MUSATAHA_CONTRACT',
};

export default function musatahaContractRegistrationReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case types.ACTION_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPDATE_MUSATAHA_CONTRACT_STATE_BY_KEY_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case types.ACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.ACTION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application') || {},
        property: get(action.payload, 'property') || {},
        applicationId: get(action.payload, 'applicationId') || null,
        mortageContracts: get(action.payload, 'mortageContracts') || [],
        owners: get(action.payload, 'owners') || [],
        developerDetails: get(action.payload, 'developerDetails') || [],
        documents: get(action.payload, 'documents') || [],
        entity: get(action.payload, 'entity') || {},
        entityAllDetails: get(action.payload, 'entityAllDetails') || {},
        PermissionId: get(action.payload, 'PermissionId') || [],
        contractDetail: get(action.payload, 'contractDetail') || {},
        error: null,
      };
    case types.CHANGE_STEP:
      return {
        ...state,
        loading: false,
        activeStep: get(action.payload, 'step'),
      };
    case types.FETCH_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: action.payload,
      };
    case types.FECTH_FEES_SUCCESS:
      return {
        ...state,
        loading: false,
        calculatedFees: action.payload,
      };

    case types.UPDATE_CONTRACT_DETAILS:
      return {
        ...state,
        contractDetail: {
          ...state.contractDetail,
          ...action.payload,
        },
      };
    case types.UPDATE_PERMISSIONS:
      let [...per] = state.PermissionId;
      if (action.payload.action === 'add') per.push(action.payload.id);
      else if (action.payload.action === 'delete') per = per.filter(item => item !== action.payload.id);
      return {
        ...state,
        PermissionId: per,
      };
    case types.ADD_MUSATEH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        entity: action.payload,
      };
    case types.DELETE_MUSATEH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        entity: {},
        entityAllDetails: {},
      };
    case types.RESET_ERROR:
      return {
        ...state,
        error: null,
        loading: false,
      };
    case types.CLEAR_DATA:
      return {
        ...defaultState,
      };
    default:
      return state;
  }
}
